import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-layout-list",
  "use": "app-icon-layout-list-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-icon-layout-list\"><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M31.5 31.5V.5H.993A.498.498 0 00.5.993v30.014c0 .268.224.493.493.493H31.5z\" stroke=\"#B8BECC\" fill=\"#FFF\" /><path fill=\"#282B33\" d=\"M8 8h1.5v1.5H8zM8 15h1.5v1.5H8zM8 22h1.5v1.5H8zM11.5 8h12v1.5h-12zM11.5 15h12v1.5h-12zM11.5 22h12v1.5h-12z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol